import { createApi } from '@reduxjs/toolkit/query/react';
import  baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';

export const iconsApi = createApi({
	reducerPath: 'iconsApi',
	tagTypes: ['icons'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getAllIcons: builder.query({
			query: () => ({
				url: `icons/all`,
			}),
			providesTags: ['icons'],
		}),
		getIcons: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `icons`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['icons'],
		}),
		deleteIcon: builder.mutation({
			query: (id: UUID) => ({
				url: `icons/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['icons'],
		}),
		addIcon: builder.mutation({
			query: ({ iconClass, name }: { name: string; iconClass: string }) => ({
				url: `icons`,
				method: 'POST',
				body: { iconClass, name },
			}),
			invalidatesTags: ['icons'],
		}),
		updateIcon: builder.mutation({
			query: ({ iconClass, name, id }: { name: string; iconClass: string; id: UUID }) => ({
				url: `icons/${id}`,
				method: 'PATCH',
				body: { iconClass, name },
			}),
			invalidatesTags: ['icons'],
		}),
	}),
});

export const { useGetAllIconsQuery,useGetIconsQuery, useDeleteIconMutation, useAddIconMutation, useUpdateIconMutation } = iconsApi;
